import sipConnectionManager from '../managers/SipConnectionManager';

const SIP_CHANNEL_TYPE = 'Channel::Sip';

const resolveWorker = async inbox => {
  let worker = sipConnectionManager.getWorker(inbox?.id);

  if (!worker && sipConnectionManager.currentUser && inbox?.id) {
    await sipConnectionManager.reconnectInbox(
      inbox,
      sipConnectionManager.currentUser
    );
    worker = sipConnectionManager.getWorker(inbox.id);
  }

  if (!worker) {
    throw new Error('SIP worker indisponivel para esta inbox.');
  }

  return worker;
};

const sipCallAdapter = {
  channelType: SIP_CHANNEL_TYPE,

  supports(inbox) {
    return inbox?.channel_type === SIP_CHANNEL_TYPE;
  },

  async startOutboundCall({ inbox, phoneNumber, contactId }) {
    const worker = await resolveWorker(inbox);
    return worker.makeCall(phoneNumber, { contactId });
  },

  async joinCall({ inbox, callSid, callDirection }) {
    const worker = await resolveWorker(inbox);

    if (callDirection === 'inbound') {
      worker.answerCall(callSid);
    }

    return { callSid };
  },

  async endCall({ inbox, callSid }) {
    const worker = await resolveWorker(inbox);
    worker.hangupCall(callSid);
    return null;
  },

  async rejectIncomingCall({ inbox, callSid }) {
    const worker = await resolveWorker(inbox);
    worker.hangupCall(callSid);
    return null;
  },

  async toggleMute({ inbox, callSid }) {
    const worker = await resolveWorker(inbox);
    return worker.toggleMicrophoneMute(callSid);
  },
};

export default sipCallAdapter;
